import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    AangifteBerekening,
    AangifteRapport, BokkzAlgDataService, Box3Berekening, ClientEntity, IncomeTaxEntity,
    OpbouwBox3, OpbouwOwr, SpecificatieBox3, SpecificatieOWR
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import { BehaviorSubject, combineLatest, Subject, takeUntil } from 'rxjs';
import {Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-inkomen-box3',
  templateUrl: './overzicht-inkomen-box3.component.html',
  styleUrls: ['./overzicht-inkomen-box3.component.scss'],
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        CommonModule,
        SharedUiAlertModule
    ]
})
export class OverzichtInkomenBox3Component implements OnInit, OnDestroy {
    @Input() public id!: string;
    private destroy$ = new Subject<void>();

    public incomeTaxEntity = {} as IncomeTaxEntity;
    public client = {} as ClientEntity;
    public clientId: any;

    specBox3FormGroup = this.fb.group<AangifteRapport>({});
    specBox3 = {} as AangifteRapport;
    specOWRFormGroup = this.fb.group<AangifteRapport>({});
    specOWR = {} as AangifteRapport;
    public laagsteRendement = 0;

    berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    berekening = {} as AangifteBerekening;
    berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>({});
    partnerBerekening = {} as AangifteBerekening;
    verdelingFormGroup = {} as FormGroup;
    box3BerekeningenFormGroup = {} as FormGroup;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder,
                            private cdr: ChangeDetectorRef,  private router: Router,) {
        this.specBox3FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBox3: this.fb.group<SpecificatieBox3>(({
                opbouw: this.fb.group<OpbouwBox3>({
                    verminderingVoordeelSparenEnBeleggen: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVermindering: null as unknown as number,
                    tijdsEvenredigeVermindering: null as unknown as number,
                    grondslagSparenEnBeleggen: 0,
                    heffingsvrijVermogenAangever: null as unknown as number,
                    heffingsvrijVermogenPartner: null as unknown as number,
                    rendementsGrondslag: null as unknown as number,
                    voordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    inkomenBox3: 0,
                    rendementBanktegoedenNederland: null as unknown as number,
                    rendementBanktegoedenBuitenland: null as unknown as number,
                    rendementBeleggingen: null as unknown as number,
                    rendementOnroerendeZakenNederland: null as unknown as number,
                    rendementOnroerendeZakenBuitenland: null as unknown as number,
                    rendementVorderingen: null as unknown as number,
                    rendementContantGeld: null as unknown as number,
                    rendementKapitaalverzekeringen: null as unknown as number,
                    rendementPeriodiekeUitkeringen: null as unknown as number,
                    rendementOverigeBezittingen: null as unknown as number,
                    rendementNettoPensioen: null as unknown as number,
                    rendementAftrekbareSchulden: null as unknown as number,
                    totaalRendement: null as unknown as number,
                    waardeBezittingenBinnenlandsePeriode: null as unknown as number,
                    waardeSchuldenBinnenlandsePeriode: null as unknown as number,
                    waardeBezittingenBuitenlandsePeriode: null as unknown as number,
                    waardeSchuldenBuitenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBinnenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBuitenlandsePeriode: null as unknown as number,
                    drempelSchuldenBinnenlandsePeriode: null as unknown as number,
                    drempelSchuldenBuitenlandsePeriode: null as unknown as number,
                    grondslagBinnenlandsePeriode: null as unknown as number,
                    grondslagBuitenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBinnenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBuitenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBinnenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBuitenlandsePeriode: null as unknown as number,
                    eldersBelasteRechtenOnroerendeZakenBuitenland: null as unknown as number,
                    verminderingVanwegeEldersBelasteRechtenBuitenland: null as unknown as number,
                    bezittingenDieMeetellenVoorTijdsevenredigeHerleidingBinnenlandsePeriode: null as unknown as number,
                    verminderingVoordeelTijdevenredigeHerleiding: null as unknown as number,
                    voordeelUitSparenEnBelegenBinnenlandsePeriode: null as unknown as number,
                    voordeelUitSparenEnBelegenBuitenlandsePeriode: null as unknown as number,
                    totaalFictiefVoordeel: null,
                })
            } as SpecificatieBox3))
        } as AangifteRapport));
        this.specOWRFormGroup = this.fb.group<AangifteRapport>(({
            specificatieOwr: this.fb.group<SpecificatieOWR>(({
                opbouw: this.fb.group<OpbouwOwr>({
                    werkelijkRendement: null as unknown as number,
                    negatiefRendement: null as unknown as number,
                    rendementBankrekeningenNederland: null as unknown as number,
                    rendementBankrekeningenBuitenland: null as unknown as number,
                    rendementBankrekeningenGroen: null as unknown as number,
                    rendementEffecten: null as unknown as number,
                    rendementEffectenGroen: null as unknown as number,
                    rendementOnroerendeZakenNl: null as unknown as number,
                    rendementOnroerendeZakenBtl: null as unknown as number,
                    rendementContantGeld: null as unknown as number,
                    rendementCrypto: null as unknown as number,
                    rendementBouwdepot: null as unknown as number,
                    rendementPremieDepot: null as unknown as number,
                    rendementVorderingen: null as unknown as number,
                    rendementKapitaalverzekeringen: null as unknown as number,
                    rendementPeriodiekeUitkeringen: null as unknown as number,
                    rendementOverigeBezittingen: null as unknown as number,
                    rendementSchuldenOgNederland: null as unknown as number,
                    rendementSchuldenOgBuitenland: null as unknown as number,
                    rendementSchuldenOgOverig: null as unknown as number
                })
            } as SpecificatieOWR))
        } as AangifteRapport));
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
            box3: this.fb.group<Box3Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox3>(({
                    voordeelUitSparenEnBeleggen: 0,
                    grondslagNaVerdeling: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    rendementsGrondslagNaVerdeling: null as unknown as number,
                    rendementsGrondslag: null as unknown as number,
                } as OpbouwBox3)),
            } as Box3Berekening)),
        } as AangifteBerekening));
        this.berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>(({
                box3: this.fb.group<Box3Berekening>(({
                    inkomen: null as unknown as number,
                    persoonsgebondenAftrek: null as unknown as number,
                    belastbaarInkomen: null as unknown as number,
                    opbouwInkomen: this.fb.group<OpbouwBox3>(({
                        voordeelUitSparenEnBeleggen: null as unknown as number,
                        grondslagNaVerdeling: null as unknown as number,
                        grondslagSparenEnBeleggen: null as unknown as number,
                        rendementsGrondslagNaVerdeling: null as unknown as number,
                        rendementsGrondslag: null as unknown as number,
                    } as OpbouwBox3)),
                } as Box3Berekening)),
            } as AangifteBerekening));
        this.verdelingFormGroup = this.fb.group({
            aandeelAangeverGrondslagSparenEnBeleggen: null as unknown as number,
            aandeelPartnerGrondslagSparenEnBeleggen: null as unknown as number,
            berekeningAandeelAangever: null as unknown as string,
            berekeningAandeelPartner: null as unknown as string,
            gecombineerdeWaardeAangever: null as unknown as string,
            gecombineerdeWaardePartner: null as unknown as string,
        })
        this.box3BerekeningenFormGroup = this.fb.group({
            percentageAangeverRendementsgrondslag: null as unknown as number,
            percentagePartnerRendementsgrondslag: null as unknown as number,
            gecombineerdeWaardeZonderPartner: null as unknown as string,
            percentageAangeverRendementsgrondslagZonderPartner: null as unknown as number,
            percentageAangeverEnPartnerRendementsgrondslag: null as unknown as number,
        })
    }

    public ngOnInit(): void {
        this.specBox3FormGroup = this.fb.group<AangifteRapport>(({
            specificatieBox3: this.fb.group<SpecificatieBox3>(({
                opbouw: this.fb.group<OpbouwBox3>({
                    verminderingVoordeelSparenEnBeleggen: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVermindering: null as unknown as number,
                    tijdsEvenredigeVermindering: null as unknown as number,
                    grondslagSparenEnBeleggen: 0,
                    heffingsvrijVermogenAangever: null as unknown as number,
                    heffingsvrijVermogenPartner: null as unknown as number,
                    rendementsGrondslag: null as unknown as number,
                    voordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    inkomenBox3: 0,
                    rendementBanktegoedenNederland: null as unknown as number,
                    rendementBanktegoedenBuitenland: null as unknown as number,
                    rendementBeleggingen: null as unknown as number,
                    rendementOnroerendeZakenNederland: null as unknown as number,
                    rendementOnroerendeZakenBuitenland: null as unknown as number,
                    rendementVorderingen: null as unknown as number,
                    rendementContantGeld: null as unknown as number,
                    rendementKapitaalverzekeringen: null as unknown as number,
                    rendementPeriodiekeUitkeringen: null as unknown as number,
                    rendementOverigeBezittingen: null as unknown as number,
                    rendementNettoPensioen: null as unknown as number,
                    rendementAftrekbareSchulden: null as unknown as number,
                    totaalRendement: null as unknown as number,
                    waardeBezittingenBinnenlandsePeriode: null as unknown as number,
                    waardeSchuldenBinnenlandsePeriode: null as unknown as number,
                    waardeBezittingenBuitenlandsePeriode: null as unknown as number,
                    waardeSchuldenBuitenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBinnenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBuitenlandsePeriode: null as unknown as number,
                    drempelSchuldenBinnenlandsePeriode: null as unknown as number,
                    drempelSchuldenBuitenlandsePeriode: null as unknown as number,
                    grondslagBinnenlandsePeriode: null as unknown as number,
                    grondslagBuitenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBinnenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBuitenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBinnenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBuitenlandsePeriode: null as unknown as number,
                    eldersBelasteRechtenOnroerendeZakenBuitenland: null as unknown as number,
                    verminderingVanwegeEldersBelasteRechtenBuitenland: null as unknown as number,
                    bezittingenDieMeetellenVoorTijdsevenredigeHerleidingBinnenlandsePeriode: null as unknown as number,
                    verminderingVoordeelTijdevenredigeHerleiding: null as unknown as number,
                    voordeelUitSparenEnBelegenBinnenlandsePeriode: null as unknown as number,
                    voordeelUitSparenEnBelegenBuitenlandsePeriode: null as unknown as number,
                    totaalFictiefVoordeel: null,
                })
            } as SpecificatieBox3))
        } as AangifteRapport));

        this.dataService.incomeTaxEntity
            .pipe(takeUntil(this.destroy$))
            .subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.berekeningPartnerFormGroup.reset();
                this.specBox3FormGroup.reset();
                this.verdelingFormGroup.reset();

                combineLatest([
                    this.dataService.aangifteRapport,
                    this.dataService.aangifteBerekening
                ])
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(([aangifteRapport, aangifteBerekening]) => {
                    this.specBox3 = aangifteRapport;
                    this.specOWR = aangifteRapport;
                    this.berekening = aangifteBerekening;
                    if (aangifteBerekening.partnerBerekening) {
                        this.partnerBerekening = aangifteBerekening.partnerBerekening;
                        this.berekeningPartnerFormGroup.patchValue(aangifteBerekening.partnerBerekening);
                    }

                    const voordeelAangever = aangifteBerekening?.box3?.opbouwInkomen?.voordeelUitSparenEnBeleggen ?? 0;
                    const voordeelPartner = aangifteBerekening.partnerBerekening?.box3?.opbouwInkomen?.voordeelUitSparenEnBeleggen ?? 0;
                    const totaalFictiefVoordeel= voordeelAangever + voordeelPartner;

                    const aandeelRendementsGrondslag = this.incomeTaxEntity.aangifte?.verdeling?.aandeelBox3;
                    const aandeelPartnerRendementsGrondslag = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelBox3;

                    const rendementsGrondslag = aangifteRapport.specificatieBox3?.opbouw?.rendementsGrondslag ?? 0              // c
                    const grondslagSparenEnBeleggen = aangifteRapport.specificatieBox3?.opbouw?.grondslagSparenEnBeleggen ?? 0  // b
                    const inkomenBox3 = aangifteRapport.specificatieBox3?.opbouw?.inkomenBox3 ?? 0                              // a
                    const aandeelAangeverInRendementsGrondslag = this.incomeTaxEntity.aangifte?.verdeling?.aandeelBox3 ?? 0
                    const aandeelPartnerInRendementsGrondslag = this.incomeTaxEntity.aangifte?.partnerAangifte?.verdeling?.aandeelBox3 ?? 0

                    if (rendementsGrondslag && rendementsGrondslag > 0) {
                        const percentageAangeverRendementsgrondslagZonderPartner = Math.floor((grondslagSparenEnBeleggen / rendementsGrondslag) * 10000) / 100;

                        // d = b / c (in %)
                        const percentageAangeverEnPartnerRendementsgrondslag = Math.floor((grondslagSparenEnBeleggen / rendementsGrondslag) * 10000) / 100;

                        // e = a * d (als long)
                        const voordeelSparenEnBeleggenVoorVermindering = Math.round(inkomenBox3 * percentageAangeverEnPartnerRendementsgrondslag / 100);

                        const percentageAangeverRendementsgrondslag = Math.floor((aandeelAangeverInRendementsGrondslag / rendementsGrondslag) * 10000) / 100;
                        const percentagePartnerRendementsgrondslag = Math.floor((aandeelPartnerInRendementsGrondslag / rendementsGrondslag) * 10000) / 100;

                        this.box3BerekeningenFormGroup.patchValue({
                            percentageAangeverRendementsgrondslag,
                            percentagePartnerRendementsgrondslag,
                            percentageAangeverRendementsgrondslagZonderPartner: percentageAangeverEnPartnerRendementsgrondslag,
                            percentageAangeverEnPartnerRendementsgrondslag,
                        });

                        // e opslaan in specBox3FormGroup
                        this.specBox3FormGroup.get('specificatieBox3')?.patchValue({opbouw: {voordeelSparenEnBeleggenVoorVermindering: voordeelSparenEnBeleggenVoorVermindering}});

                    }

                    this.berekeningFormGroup.patchValue(this.berekening);
                    this.specOWRFormGroup.patchValue(this.specOWR)
                    this.specBox3FormGroup.patchValue(this.specBox3)
                    this.specBox3FormGroup.get('specificatieBox3')?.patchValue({opbouw: {totaalFictiefVoordeel: totaalFictiefVoordeel}});

                    if (aandeelRendementsGrondslag !== undefined) {
                        this.verdelingFormGroup.patchValue({
                            aandeelAangeverGrondslagSparenEnBeleggen: aandeelRendementsGrondslag
                        })
                    } else if (this.berekening.box3?.opbouwInkomen?.rendementsGrondslag !== null) {
                        this.verdelingFormGroup.patchValue({
                            aandeelAangeverGrondslagSparenEnBeleggen: this.berekening.box3?.opbouwInkomen?.rendementsGrondslag
                        });
                    }
                    if (aandeelPartnerRendementsGrondslag !== undefined && aangifteBerekening.partnerBerekening) {
                        this.verdelingFormGroup.patchValue({
                            aandeelPartnerGrondslagSparenEnBeleggen: aandeelPartnerRendementsGrondslag
                        });
                    }

                    this.disableFormGroup(this.specBox3FormGroup);
                    this.disableFormGroup(this.specOWRFormGroup);
                    this.disableFormGroup(this.verdelingFormGroup);
                    this.disableFormGroup(this.box3BerekeningenFormGroup);
                    this.disableFormGroup(this.berekeningFormGroup);
                    this.disableFormGroup(this.berekeningPartnerFormGroup);
                    this.cdr.detectChanges();
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get gecombineerdeWaardeAangever(): string {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const aandeelAangeverInRendementsGrondslag = this.verdelingFormGroup.get(['aandeelAangeverGrondslagSparenEnBeleggen'])?.value;
        const formatter = new Intl.NumberFormat('nl-NL');
        const formattedAandeel = formatter.format(aandeelAangeverInRendementsGrondslag);
        const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);

        return `${formattedAandeel} / ${formattedRendementsGrondslag}`;
    }
    get gecombineerdeWaardePartner(): string {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const aandeelPartnerInRendementsGrondslag = this.verdelingFormGroup.get(['aandeelPartnerGrondslagSparenEnBeleggen'])?.value;
        const formatter = new Intl.NumberFormat('nl-NL');
        const formattedAandeel = formatter.format(aandeelPartnerInRendementsGrondslag);
        const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);

        return `${formattedAandeel} / ${formattedRendementsGrondslag}`;
    }
    get gecombineerdeWaardeZonderPartner(): string {
        const rendementsGrondslag = this.specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value;
        const grondslagSparenEnBeleggen = this.berekeningFormGroup.get(['box3', 'opbouwInkomen', 'grondslagSparenEnBeleggen'])?.value;
        const formatter = new Intl.NumberFormat('nl-NL');
        const formattedGrondslag = formatter.format(grondslagSparenEnBeleggen);
        const formattedRendementsGrondslag = formatter.format(rendementsGrondslag);

        return `${formattedGrondslag} / ${formattedRendementsGrondslag}`;
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}
